import { ViewId } from '../types';

interface Props {
  current: ViewId;
  counts: Partial<Record<ViewId, number>>;
  onNavigate: (view: ViewId) => void;
}

interface NavItem {
  id: ViewId;
  label: string;
  icon: string;
  group?: string;
}

const NAV_ITEMS: NavItem[] = [
  { id: 'all', label: 'All Tasks', icon: '◈', group: 'views' },
  { id: 'urgent', label: 'Urgent', icon: '⚡', group: 'views' },
  { id: 'today', label: 'Due Today', icon: '◷', group: 'views' },
  { id: 'completed', label: 'Completed', icon: '✓', group: 'views' },
  { id: 'gmail', label: 'Gmail', icon: '✉', group: 'sources' },
  { id: 'slack', label: 'Slack', icon: '#', group: 'sources' },
  { id: 'calls', label: 'Calls', icon: '◎', group: 'sources' },
  { id: 'manual', label: 'Manual', icon: '✦', group: 'sources' },
  { id: 'settings', label: 'Settings', icon: '⚙', group: 'settings' },
];

export function Sidebar({ current, counts, onNavigate }: Props) {
  return (
    <aside className="w-48 shrink-0 bg-gray-900 border-r border-gray-800 flex flex-col py-4 px-2 gap-1">
      <div className="mb-2">
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider px-3 mb-1">
          Views
        </p>
        {NAV_ITEMS.filter((i) => i.group === 'views').map((item) => (
          <NavButton key={item.id} item={item} current={current} count={counts[item.id]} onNavigate={onNavigate} />
        ))}
      </div>

      <div className="mb-2">
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider px-3 mb-1">
          Sources
        </p>
        {NAV_ITEMS.filter((i) => i.group === 'sources').map((item) => (
          <NavButton key={item.id} item={item} current={current} count={counts[item.id]} onNavigate={onNavigate} />
        ))}
      </div>

      <div className="mt-auto">
        {NAV_ITEMS.filter((i) => i.group === 'settings').map((item) => (
          <NavButton key={item.id} item={item} current={current} count={counts[item.id]} onNavigate={onNavigate} />
        ))}
      </div>
    </aside>
  );
}

function NavButton({
  item,
  current,
  count,
  onNavigate,
}: {
  item: NavItem;
  current: ViewId;
  count?: number;
  onNavigate: (v: ViewId) => void;
}) {
  const active = current === item.id;
  return (
    <button
      onClick={() => onNavigate(item.id)}
      className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition group ${
        active
          ? 'bg-indigo-600 text-white'
          : 'text-gray-400 hover:bg-gray-800 hover:text-gray-200'
      }`}
    >
      <span className="w-4 text-center text-xs">{item.icon}</span>
      <span className="flex-1 text-left">{item.label}</span>
      {count !== undefined && count > 0 && (
        <span
          className={`text-xs font-medium px-1.5 py-0.5 rounded-full ${
            active ? 'bg-indigo-500 text-white' : 'bg-gray-700 text-gray-400'
          }`}
        >
          {count}
        </span>
      )}
    </button>
  );
}
